import { render } from "./BaseDropdown.vue?vue&type=template&id=651eb6a2&ts=true"
import script from "./BaseDropdown.vue?vue&type=script&lang=ts"
export * from "./BaseDropdown.vue?vue&type=script&lang=ts"

import "./BaseDropdown.vue?vue&type=style&index=0&id=651eb6a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__